import { render, staticRenderFns } from "./AddPessoa.vue?vue&type=template&id=1e3a88a5&scoped=true&"
import script from "./AddPessoa.vue?vue&type=script&lang=js&"
export * from "./AddPessoa.vue?vue&type=script&lang=js&"
import style0 from "./AddPessoa.vue?vue&type=style&index=0&id=1e3a88a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3a88a5",
  null
  
)

export default component.exports